import { render, staticRenderFns } from "./voyage.vue?vue&type=template&id=325745e1&scoped=true&"
import script from "./voyage.vue?vue&type=script&lang=js&"
export * from "./voyage.vue?vue&type=script&lang=js&"
import style0 from "./voyage.vue?vue&type=style&index=0&id=325745e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325745e1",
  null
  
)

export default component.exports